var sensors = window['sensorsDataAnalytic201505'];

function trackEvent(eventName, properties) {
  sensors.track(eventName, properties)
}


sensors.init({
  // server_url: 'https://zs-event-test.ur.com.cn/api/upload/event?project=project_e4be95b8ced64334bf1b0ad3b14e07a3',
  server_url: 'https://zs-event.ur.com.cn/api/upload/event?project=project_f1202264ad9b47029dc716a9f152627b',
  heatmap: {
    // routerMode: 'hash', // 路由模式是hash时需要加上这个配置, history模式不需要
  },
  send_type: 'ajax',
  publicProperties: { // 公共属性
    $system_version: 'v3.0.4', // 当前项目版本号
  },
  show_log: false,
  // env: 'development', // 如果是非生产环境，传递development
  env: 'production', // 如果是非生产环境，传递development
});
sensors.logout(true)
var userid = localStorage.getItem('account_ident')
if (userid) {
  sensors.login(userid);
}

var exposure = sensors.use(SensorsDataWebJSSDKPlugin.Exposure,  {
  area_rate: 0.7, 
  stay_duration: .4, 
  repeated: false 
})
